import { createSelector } from '@ngrx/store';

import { MANDATORY_LEGAL_DOCUMENTS } from '../../MandatoryLegalDocuments';
import { LegalDocument } from '../../model/LegalDocument';
import { LegalDocumentApproval } from '../../model/LegalDocumentApproval';
import { LEGAL_DOCUMENTS_TYPES } from '../../model/LegalDocumentType';
import { getLegalDocumentsState } from '../reducers/legalDocument';

export const getApprovedLegalDocuments = createSelector(
    getLegalDocumentsState,
    (state): LegalDocumentApproval => ({
        approvalDate: state.approvalDate,
        approvedDocuments: Object.values(state.documents).filter((doc: LegalDocument) =>
            MANDATORY_LEGAL_DOCUMENTS.includes(doc.documentType),
        ),
    }),
);

export const getDocumentsToSign = createSelector(getLegalDocumentsState, (state) => state.documentsToSign);

export const getLegalNoticeUrl = createSelector(getLegalDocumentsState, (state) => {
    const legalNoticeDocument = Object.values(state.documents).find(
        (doc: LegalDocument) => doc.documentType === LEGAL_DOCUMENTS_TYPES.SPECIAL_TERMS,
    );
    return legalNoticeDocument?.url;
});
